import { observable } from "mobx";
import { Type } from "class-transformer";
import MessageListItem from "./messageListItem";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RspMessageList {
  @observable
  total!: number;

  @observable
  @Type(() => MessageListItem)
  messages!: MessageListItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    messages: { required: true },
  };
}
